import React, { useEffect, useRef } from "react";
import {
  CRow,
  CCol,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import Swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";
import {
  setApoDocHdwtData,
  setModifyApoDocHdwtData,
} from "src/modules/apoDocForm";

const ApoDocHdwtRegPop = (props) => {
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  const state = useSelector((state) => state);
  const { name } = useSelector((state) => state.insert.reqTaskInfo);
  const dispatch = useDispatch();
  const backCanvasRef = useRef(null);
  const drawCanvasRef = useRef(null);
  const etcYn = props.etcYn;
  const FILL_TEXT = state.apoDocForm.apoDocHdwtInfo[etcYn].text;
  const CANVAS_WIDTH = 300;
  const CANVAS_HEIGHT = 150;
  const CANVAS_HEIGHT_SUB = 50;
  let context, drawCanvas, tool;

  function isCanvasBlank(drawCanvas) {
    return !drawCanvas
      .getContext("2d")
      .getImageData(0, 0, drawCanvas.width, drawCanvas.height)
      .data.some((channel) => channel !== 0);
  }

  function getSignatureSize(drawCanvas) {
    const context = drawCanvas.getContext('2d');
    const imageData = context.getImageData(0, 0, drawCanvas.width, drawCanvas.height);
    const pixels = imageData.data;

    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    // Loop through pixels to find the bounding box of the signature
    for (let y = 0; y < drawCanvas.height; y++) {
        for (let x = 0; x < drawCanvas.width; x++) {
            const pixelIndex = (y * drawCanvas.width + x) * 4; // Index of the current pixel in the pixel array
            const alpha = pixels[pixelIndex + 3]; // Alpha value (transparency) of the pixel

            if (alpha !== 0) { // Non-transparent pixel
                minX = Math.min(minX, x);
                minY = Math.min(minY, y);
                maxX = Math.max(maxX, x);
                maxY = Math.max(maxY, y);
            }
        }
    }

    // Calculate width and height of the signature
    const signatureWidth = maxX - minX + 1;
    const signatureHeight = maxY - minY + 1;

    return { width: signatureWidth, height: signatureHeight };
  }

  function isSignatureLargeEnough(drawCanvas) {
    const { width, height } = getSignatureSize(drawCanvas);
    return width >= 35 && height >= 15;
  }

  const onSave = () => {
    const canv = drawCanvasRef.current;
    const changeData = [];
    let hdwtCatCd = "";

    switch (etcYn) {
      case 0:
        hdwtCatCd = "D01";
        break;
      case 1:
        hdwtCatCd = "D02";
        break;
      case 2:
        hdwtCatCd = "D03";
        break;
      default:
        break;
    }

    if (isCanvasBlank(canv))
      return Swal("", "작성한 내용이 없으면 저장할 수 없습니다.", "error");

    if(!isSignatureLargeEnough(canv)) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      return Swal("", "조금 더 큰 사이즈로 정확하게 서명해주세요.", "info");
    }

    const imgBase64 = canv.toDataURL("image/png", 1);
    // const decodImg = atob(imgBase64.split(",")[1]);
    // let array = [];

    // for (let item of decodImg) {
    //   array.push(item.charCodeAt);
    // }

    // const file = new Blob([new Uint8Array(array)], { type: "image/jpeg" });
    // const fileName = "canvas_img_" + new Date().getMilliseconds() + ".jpg";
    // let formData = new FormData();
    // formData.append("file", file, fileName);
    changeData.push({
      HDWT_CAT_CD: hdwtCatCd,
      IMG_DATA: imgBase64,
    });

    dispatch(setApoDocHdwtData(changeData, false));
    props.onClose();
  };

  const onModify = () => {
    dispatch(setModifyApoDocHdwtData(etcYn));
  };

  useEffect(() => {
    const backCanvas = backCanvasRef.current;
    drawCanvas = drawCanvasRef.current;
    context = drawCanvas.getContext("2d");
    const context2 = backCanvas.getContext("2d");
    var text = (etcYn === 0) ? name : FILL_TEXT;
    var maxWidth = backCanvas.width; // 최대 너비
    var fontSize = 50; // 시작 폰트 크기

    context.lineWidth = 2;

    do {
      context2.font = fontSize + "px Noto Sans KR, sans-serif";
      var textWidth = context2.measureText(text).width;
      fontSize--; // 폰트 크기를 줄여가며 너비를 확인

    } while (textWidth > maxWidth && fontSize > 0);

    context2.textBaseline = "middle";
    context2.textAlign = "center";
    context2.stroke();
    // context2.font = `normal ${etcYn === 0 ? '3em' : etcYn === 1 ? '2.25em' : '1.75em'} Noto Sans KR, sans-serif`;
    context2.fillStyle = "#ababab";
    context2.fillText(text, CANVAS_WIDTH / 2, CANVAS_HEIGHT / 2);

    tool = new tool_pencil();
    drawCanvas.addEventListener("mousedown", draw_canvas, false);
    drawCanvas.addEventListener("mousemove", draw_canvas, false);
    drawCanvas.addEventListener("mouseup", draw_canvas, false);
    drawCanvas.addEventListener("mouseout", draw_canvas, false);
    drawCanvas.addEventListener("touchstart", draw_canvas, false);
    drawCanvas.addEventListener("touchmove", draw_canvas, false);
    drawCanvas.addEventListener("touchend", draw_canvas, false);
    drawCanvas.addEventListener("touchcancel", draw_canvas, false);
  }, []);

  function tool_pencil() {
    var tool = this;
    this.started = false;

    this.mousedown = function (e) {
      context.beginPath();
      context.moveTo(e._x, e._y);
      tool.started = true;
    };
    this.mousemove = function (e) {
      if (tool.started) {
        context.lineTo(e._x, e._y);
        context.stroke();
      }
    };
    this.mouseup = function (e) {
      if (tool.started) {
        tool.mousemove(e);
        tool.started = false;
      }
    };
    this.mouseout = function (e) {
      if (tool.started) {
        tool.mousemove(e);
        tool.started = false;
      }
    };
    
    this.touchstart = function (e) {
      context.beginPath();
      context.moveTo(e._x, e._y);
      tool.started = true;
    };
    this.touchmove = function (e) {
      if (tool.started) {
        context.lineTo(e._x, e._y);
        context.stroke();
      }
    };
    this.touchend = function (e) {
      if (tool.started) {
        tool.touchmove(e);
        tool.started = false;
      }
    };
    this.touchcancel = function (e) {
      if (tool.started) {
        tool.touchmove(e);
        tool.started = false;
      }
    };
  }
  
  function draw_canvas(e) {
    e.preventDefault();
    e.stopPropagation();
    var canvas = document.getElementById("drawCanvas");
    var bound = canvas.getBoundingClientRect();
    var bw = 1;

    if (e.clientX && e.clientX > 0) {
      e._x =
        (e.clientX - bound.left - bw) * (canvas.width / (bound.width - bw * 2));
      e._y =
        (e.clientY - bound.top - bw) *
        (canvas.height / (bound.height - bw * 2));
    }
    if (e.touches && e.touches.length > 0) {
      // 핸드폰
      // var left = 0;
      // var top = 0;

      // while (canvas) {
      //   left = left + parseInt(canvas.offsetLeft);
      //   top = top + parseInt(canvas.offsetTop);
      //   canvas = canvas.offsetParent;
      // }

      // e._x = e.touches[0].clientX - left;
      // e._y = e.touches[0].clientY - top;

      e._x =
        (e.touches[0].clientX - bound.left - bw) *
        (canvas.width / (bound.width - bw * 2));
      e._y =
        (e.touches[0].clientY - bound.top - bw) *
        (canvas.height / (bound.height - bw * 2));
    }

    var func = tool[e.type];
    if (func) {
      func(e);
    }
  }

  function onClear() {
    drawCanvas = document.getElementById("drawCanvas");
    context = drawCanvas.getContext("2d");
    context.save();
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
    context.restore();
  }

  return (
    <>
      <CModal
        show={true}
        centered={true}
        closeOnBackdrop={false}
        onClosed={() => props.onClose(false)}
      >
        <CModalHeader className="modal-header" closeButton>
          <CModalTitle>자필입력</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>
            {etcYn === 0 ? (
              <CCol xs="12">
                <h6>
                  <b>휴대폰 화면을 가로로 놓고 작성해주세요.</b>
                </h6>
                <h5>
                  모든 보험사 위촉서류내용에 대해 충분히 이해하고 숙지하였으며,
                  이에 대한 동의의 의사표시로 자필서명 합니다.
                </h5>
              </CCol>
            ) : (
              <CCol xs="12">
                <h6>
                  <b>휴대폰 화면을 가로로 놓고 작성해주세요.</b>
                </h6>
                <h5 className="modal-infoText">
                  아래의 내용을 확인하시고, 자필로 작성해주세요.
                </h5>
                <h5>{`"${FILL_TEXT}"`}</h5>
              </CCol>
            )}
            {state.apoDocForm.apoDocHdwtInfo[etcYn].data ? (
              <>
                <CCol xs="12" className="wrap_canvas showContent">
                  <img
                    src={state.apoDocForm.apoDocHdwtInfo[etcYn].data}
                    className="canvasPrevImg"
                    alt="prevTextImg"
                  />
                </CCol>
                <CCol xs="12" className="wrap_canvas hideContent">
                  <canvas
                    display="none"
                    ref={backCanvasRef}
                    id="backCanvas"
                    width={CANVAS_WIDTH}
                    height={props.etcYn ?  CANVAS_HEIGHT_SUB : CANVAS_HEIGHT}
                    className={`canvas ${props.display}`}
                  ></canvas>
                  <canvas
                    display="none"
                    ref={drawCanvasRef}
                    id="drawCanvas"
                    width={CANVAS_WIDTH}
                    height={props.etcYn ?  CANVAS_HEIGHT_SUB : CANVAS_HEIGHT}
                    className={`canvas ${props.display}`}
                  ></canvas>
                </CCol>
              </>
            ) : (
              <>
                <CCol xs="12" className="wrap_canvas hideContent">
                  <img
                    src={state.apoDocForm.apoDocHdwtInfo[etcYn].data}
                    className="canvasPrevImg"
                    alt="prevTextImg"
                  />
                </CCol>
                <CCol xs="12" className="wrap_canvas showContent">
                  <canvas
                    ref={backCanvasRef}
                    id="backCanvas"
                    width={CANVAS_WIDTH}
                    height={props.etcYn ?  CANVAS_HEIGHT_SUB : CANVAS_HEIGHT}
                    className={`canvas ${props.display}`}
                  ></canvas>
                  <canvas
                    ref={drawCanvasRef}
                    id="drawCanvas"
                    width={CANVAS_WIDTH}
                    height={props.etcYn ?  CANVAS_HEIGHT_SUB : CANVAS_HEIGHT}
                    className={`canvas ${props.display}`}
                  ></canvas>
                </CCol>
              </>
            )}
          </CRow>
        </CModalBody>
        <CModalFooter className="display-block modal-footer">
          {state.apoDocForm.apoDocHdwtInfo[etcYn].data ? (
            <div className="layout-footer">
              <button className="btn-footer" type="button" onClick={onModify}>
                  다시작성
              </button>
            </div>
            // <CButton color="info" onClick={onModify}>
            //   다시작성
            // </CButton>
          ) : (
            <div className="layout-footer">
              <button className="btn-footer type-gray" type="button" onClick={onClear}>
                  초기화
              </button>
              <button className="btn-footer" type="button" onClick={onSave}>
                  저장
              </button>
            </div>
          )}
        </CModalFooter>
      </CModal>
    </>
  );
};

export default ApoDocHdwtRegPop;
